import * as React from 'react';
import { useSelector } from 'react-redux';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { trackOpenContacts, trackShowPhone } from '../../actions/analytics';
import { CallButtonContainer } from '../CallButton';
import { getGaLabel } from '../../selectors/analytics';
import { getBuilders } from '../../selectors/newbuilding';
import { hasValidPhone } from '../../utils/agent';

export interface ICallToActionContainerProps {
  analyticOnOpenActionName?: string;
  dynamicCalltrackingPlaceType: string;
  fullWidth?: boolean;
  secondary?: boolean;
  XXL?: boolean;
  size?: TButtonSize;
  onPhoneShow?: () => void;
}

export const CallToActionContainer: React.FC<ICallToActionContainerProps> = ({
  analyticOnOpenActionName,
  dynamicCalltrackingPlaceType,
  fullWidth,
  secondary,
  XXL,
  size,
  onPhoneShow,
}) => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);

  const isBuildersWithPhones = React.useMemo(() => {
    return builders.some(hasValidPhone);
  }, [builders]);

  const handleOpenContacts = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  const handleShowPhone = React.useCallback(() => {
    trackShowPhone(gaLabel, analyticOnOpenActionName);
    onPhoneShow?.();
  }, [analyticOnOpenActionName, gaLabel, onPhoneShow]);

  const buttonStyles = React.useMemo(() => {
    return {
      size: size ?? (XXL ? ('M' as const) : ('XS' as const)),
      theme: secondary ? ('fill_secondary' as const) : ('fill_primary' as const),
      fullWidth,
      beforeIcon: <IconCommunicationPhone16 color={secondary ? 'icon-main-default' : 'icon-inverted-default'} />,
    };
  }, [fullWidth, secondary, size, XXL]);

  return (
    <CallButtonContainer
      openContactsStyles={buttonStyles}
      showPhoneStyles={buttonStyles}
      onOpenContactsClick={handleOpenContacts}
      onShowPhoneClick={handleShowPhone}
      placeType={dynamicCalltrackingPlaceType}
      singlePhoneButtonText={isBuildersWithPhones ? 'Контакты застройщика' : 'Контакты продавца'}
      multiplePhoneButtonText={isBuildersWithPhones ? 'Контакты застройщика' : 'Контакты продавца'}
    />
  );
};
